// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1_hXt","title":"ClientCherryInfo_title__1tmlC","itemText":"ClientCherryInfo_itemText__2TBTb"};